/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackEnum } from './APIFeedbackEnum';
import {
    APIFeedbackEnumFromJSON,
    APIFeedbackEnumFromJSONTyped,
    APIFeedbackEnumToJSON,
} from './APIFeedbackEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProductionFeedbackRequest
 */
export interface APIProductionFeedbackRequest {
    /**
     * 
     * @type {APIFeedbackEnum}
     * @memberof APIProductionFeedbackRequest
     */
    feedback: APIFeedbackEnum;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionFeedbackRequest
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof APIProductionFeedbackRequest
     */
    count: number;
}



/**
 * Check if a given object implements the APIProductionFeedbackRequest interface.
 */
export function instanceOfAPIProductionFeedbackRequest(value: object): value is APIProductionFeedbackRequest {
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function APIProductionFeedbackRequestFromJSON(json: any): APIProductionFeedbackRequest {
    return APIProductionFeedbackRequestFromJSONTyped(json, false);
}

export function APIProductionFeedbackRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProductionFeedbackRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'feedback': APIFeedbackEnumFromJSON(json['feedback']),
        'time': (new Date(json['time'])),
        'count': json['count'],
    };
}

export function APIProductionFeedbackRequestToJSON(value?: APIProductionFeedbackRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'feedback': APIFeedbackEnumToJSON(value['feedback']),
        'time': ((value['time']).toISOString()),
        'count': value['count'],
    };
}

